export default __webpack_public_path__ + "static/media/canon-camera.c05e9d3e.jpg";